import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-gooey-loader',
    templateUrl: './gooey-loader.component.html',
    styleUrls: ['./gooey-loader.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GooeyLoaderComponent {
}
